/* grid density v4 2026-10-09 — Apple Photos–style pinch on mobile/touch (1–4 per row). No libraries.
   Perf contract:
   - During the gesture: only `transform: scale()` on ONE element (the grid), will-change set at gesture start, one write per rAF.
     No layout reads/writes, no per-card styles. Sliders get pointer-events:none; image loading + infinite scroll are paused
     (window.__intiGesture).
   - On release: column count changes exactly once (one layout pass), then a FLIP limited to cards near the viewport, played by the
     compositor (Web Animations API) with a spring curve baked into a linear() easing. Off-screen cards just snap.
   - After the settle: image `sizes` are updated for the new density (idle), gesture flag cleared, paused work resumes. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var MOB = [1, 2, 3, 4], KEY = 'iv_grid_density_m', root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function getGrid() { return document.querySelector('ul.product-grid'); }
  if (!getGrid()) return;
  function cur(grid) { return +grid.dataset.density || 2; }
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 60); };
  // sizes are re-applied in small idle slices (in-viewport cards first), never during a gesture
  var sizeJob = 0;
  function sizeImgs(grid, n) {
    var sizes = 'calc((100vw - 35px) / ' + n + ')'; // srcset 240/360/480/720 (cap 720)
    var imgs = Array.prototype.slice.call(grid.querySelectorAll('.card__media img[sizes]'));
    var job = ++sizeJob, i = 0;
    function slice(dl) {
      if (job !== sizeJob) return;
      if (window.__intiGesture) { idle(slice, { timeout: 500 }); return; }
      var end = Math.min(imgs.length, i + 12);
      for (; i < end; i++) {
        var img = imgs[i];
        if (/^\(max-width: 989px\) 1px/.test(img.sizes)) continue;
        if (!img.dataset.origSizes) img.dataset.origSizes = img.sizes;
        if (img.sizes !== sizes) img.sizes = sizes;
      }
      if (i < imgs.length) idle(slice, { timeout: 500 });
    }
    slice();
  }
  // grid position cached outside the gesture so touchstart never forces a layout
  var geo = null;
  function measure() { var g = getGrid(); if (!g) return; var r = g.getBoundingClientRect(); geo = { top: r.top + scrollY, left: r.left + scrollX }; }
  idle(measure, { timeout: 1000 });
  addEventListener('resize', function () { geo = null; idle(measure, { timeout: 1000 }); });
  function setCols(grid, n, save) {
    grid.dataset.density = n;
    if (save) try { sessionStorage.setItem(KEY, n); } catch (e) {}
  }
  function unzoomed() { return !window.visualViewport || window.visualViewport.scale <= 1.01; }
  function owns() { return mq.matches && unzoomed(); }
  function sync() {
    var grid = getGrid(); if (!grid) return;
    var s = null; try { s = +sessionStorage.getItem(KEY); } catch (e) {}
    if (mq.matches && s && MOB.indexOf(s) >= 0) { setCols(grid, s, false); sizeImgs(grid, s); }
    else {
      delete grid.dataset.density;
      grid.querySelectorAll('.card__media img[data-orig-sizes]').forEach(function (img) { img.sizes = img.dataset.origSizes; });
    }
    if (owns()) grid.dataset.pinch = ''; else delete grid.dataset.pinch;
  }
  sync();
  mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', function () {
    var grid = getGrid(); if (!grid) return; if (owns()) grid.dataset.pinch = ''; else delete grid.dataset.pinch;
  });
  var pgc = document.getElementById('ProductGridContainer');
  if (pgc) new MutationObserver(function () { var g = getGrid(); if (g && !g.dataset.densitySynced) { g.dataset.densitySynced = '1'; sync(); geo = null; idle(measure, { timeout: 1000 }); } }).observe(pgc, { childList: true });
  var g0 = getGrid(); if (g0) g0.dataset.densitySynced = '1';
  document.addEventListener('inti:grid-append', function () { var grid = getGrid(); if (grid && grid.dataset.density) sizeImgs(grid, +grid.dataset.density); idle(measure, { timeout: 1000 }); });

  // Gesture flag is a JS property (window.__intiGesture), not a DOM attribute, so toggling it costs no style recalc.
  // Sliders are paused with ONE transparent shield over the grid (no inherited-property change on 77 cards).
  var shield = null;
  function begin(grid) {
    window.__intiGesture = true;
    if (!shield) { shield = document.createElement('div'); shield.className = 'inti-pinch-shield'; shield.setAttribute('aria-hidden', 'true'); }
    if (shield.parentNode !== grid.parentNode) grid.parentNode.insertBefore(shield, grid);
    shield.hidden = false;
  }
  function finish(grid) {
    if (shield) shield.hidden = true;
    idle(function () {
      if (grid.dataset.density) sizeImgs(grid, +grid.dataset.density);
      window.__intiGesture = false;
      document.dispatchEvent(new CustomEvent('inti:gesture-end'));
    }, { timeout: 300 });
  }

  // ---------------- gesture ----------------
  var G = null, raf = 0, running = [];
  function dist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }
  function rubber(s, lo, hi) { return s > hi ? hi + (s - hi) * 0.3 : s < lo ? lo - (lo - s) * 0.3 : s; }
  function paint() { raf = 0; if (G) G.grid.style.transform = 'scale(' + G.s.toFixed(4) + ')'; }
  document.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 2 || !owns()) return;
    var grid = getGrid(); if (!grid || !grid.contains(e.target)) return;
    if (running.length) { running.forEach(function (a) { a.finish(); }); running = []; }
    if (!geo) measure(); // normally pre-cached, so no forced layout here
    var t = e.touches, r = { left: geo.left - scrollX, top: geo.top - scrollY };
    var mx = (t[0].clientX + t[1].clientX) / 2, my = (t[0].clientY + t[1].clientY) / 2, c = cur(grid);
    G = { grid: grid, d0: dist(t), s: 1, cols: c, mx: mx, my: my, lo: c / 4.4, hi: c / 0.9, v: 0, lt: e.timeStamp, ls: 1 };
    grid.style.transformOrigin = (mx - r.left) + 'px ' + (my - r.top) + 'px';
    grid.style.willChange = 'transform';
    begin(grid);
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!G || e.touches.length !== 2) return;
    e.preventDefault();
    var s = rubber(dist(e.touches) / G.d0, G.lo, G.hi), dt = e.timeStamp - G.lt;
    if (dt > 4) { G.v = 0.8 * ((s - G.ls) / dt) + 0.2 * G.v; G.lt = e.timeStamp; G.ls = s; }
    G.s = s;
    if (!raf) raf = requestAnimationFrame(paint);
  }, { passive: false });
  function end(e) {
    if (!G || (e.touches && e.touches.length >= 2)) return;
    var st = G; G = null; if (raf) { cancelAnimationFrame(raf); raf = 0; }
    if (performance.now() - st.lt > 80) st.v = 0;
    settle(st);
  }
  document.addEventListener('touchend', end, { passive: true });
  document.addEventListener('touchcancel', end, { passive: true });
  ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (t) {
    document.addEventListener(t, function (e) { var grid = getGrid(); if (G || (owns() && grid && grid.contains(e.target))) e.preventDefault(); }, { passive: false });
  });

  // spring (k=110, critically damped) sampled into a CSS linear() easing so the compositor plays it
  var hasLinear = window.CSS && CSS.supports && CSS.supports('transition-timing-function', 'linear(0, 1)');
  function springEasing(v0) {
    var k = 110, c = 2 * Math.sqrt(k), x = 0, v = v0, dt = 1 / 240, pts = [0], t = 0;
    while (t < 2 && !(Math.abs(1 - x) < 0.002 && Math.abs(v) < 0.02)) {
      var a = -k * (x - 1) - c * v; v += a * dt; x += v * dt; if (x > 1) { x = 1; v = 0; } t += dt;
      if (Math.round(t * 240) % 8 === 0) pts.push(+x.toFixed(4));
    }
    pts.push(1);
    return { easing: hasLinear ? 'linear(' + pts.join(',') + ')' : 'cubic-bezier(.22,1,.36,1)', duration: Math.round(Math.min(900, Math.max(450, t * 1000))) };
  }

  function settle(st) {
    var grid = st.grid;
    var proj = Math.max(0.2, st.s + Math.max(-0.5, Math.min(0.5, st.v * 120)));
    var target = Math.min(4, Math.max(1, Math.round(st.cols / proj)));
    function done() { running = []; grid.style.willChange = ''; grid.style.transformOrigin = ''; finish(grid); }
    if (reduce) { grid.style.transform = ''; if (target !== st.cols) setCols(grid, target, true); return done(); }
    if (target === st.cols) {
      var sp0 = springEasing(0);
      grid.style.transform = '';
      var a0 = grid.animate([{ transform: 'scale(' + st.s + ')' }, { transform: 'scale(1)' }], sp0);
      running = [a0]; a0.finished.then(done, done);
      return;
    }
    // FIRST: rects of cards in/near the viewport only (layout is clean; the gesture only changed a transform)
    var vh = innerHeight, near = [], best = 1e9, anchor = -1, lis = grid.children;
    // binary-ish skip: cards are in DOM order, so stop once we're well below the viewport
    for (var i = 0; i < lis.length; i++) {
      var r = lis[i].getBoundingClientRect();
      if (r.bottom < -vh * 0.25) continue;
      if (r.top > vh * 1.25) break;
      near.push({ el: lis[i], f: r });
      var d = Math.hypot(r.left + r.width / 2 - st.mx, r.top + r.height / 2 - st.my);
      if (d < best) { best = d; anchor = near.length - 1; }
    }
    // WRITE once: drop the gesture transform, switch columns (sizes stay untouched until after the settle)
    grid.style.transform = '';
    setCols(grid, target, true);
    // READ once: the single layout pass
    var last = near.map(function (it) { return it.el.getBoundingClientRect(); });
    var gr = grid.getBoundingClientRect(); geo = { top: gr.top + scrollY, left: gr.left + scrollX }; // free: layout is already clean here
    var dy = 0;
    if (anchor >= 0) { var a = near[anchor], al = last[anchor]; dy = (al.top + al.height / 2) - (a.f.top + a.f.height / 2); }
    if (Math.abs(dy) > 0.5) window.scrollBy(0, dy);
    // PLAY on the compositor
    var gap = Math.abs(st.cols / target - st.s) || 1;
    var v0 = ((st.cols / target - st.s) * st.v > 0) ? Math.min(8, Math.abs(st.v) * 1000 / gap) : 0;
    var sp = springEasing(v0);
    running = [];
    near.forEach(function (it, j) {
      var l = last[j]; if (!l.width) return;
      var ly = l.top - dy;
      if (ly > vh * 1.25 && it.f.top > vh * 1.25) return;
      if (ly + l.height < -vh * 0.25 && it.f.bottom < -vh * 0.25) return;
      var sx = it.f.width / l.width, sy = it.f.height / l.height, tx = it.f.left - l.left, ty = it.f.top - ly;
      running.push(it.el.animate([
        { transformOrigin: '0 0', transform: 'translate(' + tx + 'px,' + ty + 'px) scale(' + sx + ',' + sy + ')' },
        { transformOrigin: '0 0', transform: 'none' }
      ], sp));
    });
    if (!running.length) return done();
    Promise.all(running.map(function (x) { return x.finished.catch(function () {}); })).then(done);
  }
})();
